import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseDirective } from './base.directive';
import { AnimationLoader } from './animation-loader';
import { LottieDirective } from './lottie.directive';
import { LottieComponent } from './lottie.component';
import { LOTTIE_OPTIONS } from './symbols';
import * as ɵngcc0 from '@angular/core';
export class LottieModule {
    static forRoot(options) {
        return {
            ngModule: LottieModule,
            providers: [
                AnimationLoader,
                {
                    provide: LOTTIE_OPTIONS,
                    useValue: options,
                },
            ],
        };
    }
}
LottieModule.ɵfac = function LottieModule_Factory(t) { return new (t || LottieModule)(); };
LottieModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LottieModule });
LottieModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LottieModule, { declarations: function () { return [BaseDirective, LottieDirective, LottieComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BaseDirective, LottieDirective, LottieComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LottieModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [BaseDirective, LottieDirective, LottieComponent],
                exports: [BaseDirective, LottieDirective, LottieComponent]
            }]
    }], null, null); })();

//# sourceMappingURL=lottie.module.js.map